import { mediaUploadAbort } from '@/state/mutations/media/media-upload-api.ts';

export type MediaUploadSessionRef = {
  mediaId: string;
  uploadId: string;
};

/** Best-effort server abort so quota reservations and pending assets are released. */
export async function abortMediaUploadSession(
  session: MediaUploadSessionRef | null | undefined,
  getToken: () => Promise<string | null>,
): Promise<void> {
  if (!session) {
    return;
  }

  try {
    const token = await getToken();
    if (!token) {
      return;
    }
    await mediaUploadAbort(session.mediaId, { uploadId: session.uploadId }, token);
  } catch {
    // Quota is also released by stale-session cron; abort is best-effort here.
  }
}
